import React, { useState, useEffect } from "react";
import { Table, Tag, Tooltip, Spin, Button, Input } from "antd";
import { getCsvUploadedList, getInlineImageForCsvUpload } from "../../API/api";
import { momentit } from "../../utils";
import {
  DownloadOutlined,
  SyncOutlined,
  SearchOutlined,
} from "@ant-design/icons";

export default function CrawlDocsTable() {
  const [rows, setRowData] = React.useState([]);
  const [origRows, setOrigRowData] = React.useState([]);
  const [isLoading, setLoading] = useState(false);
  const [isRefreshing, setRefreshing] = useState(false);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 10,
    },
  });
  const [tabSearch, settabSearch] = useState('');
  const onChangeFilterStr = (str) => {
    settabSearch(str);
    if (str === "") {
      setRowData(origRows);
    } else {
      let filteredData = origRows.filter((obj) => {
        if (obj.fileName.toLowerCase().includes(str.toLowerCase())) {
          return obj;
        }
      });
      setRowData(filteredData);
    }
  };
  const renderTitle = (title, position='center') => {
    return (
      <div style={{ textAlign: position }}>
        <span style={{ fontWeight: "500", fontSize: "18px" }}>{title}</span>
      </div>
    );
  };
  const tooltipTitle=(str)=>{
    return(
      <span style={{color:'black'}}>{str}</span>
    )
  }
  const renderPara = (title) => {
    return (
      <div style={{ textAlign: "start" }}>
        <span style={{    fontSize: "13px",
          color: "#2A364A",
          fontWeight: "500", }}>{title}</span>
      </div>
    );
  };
  const renderUrl = (url) => {
    return (
      <div style={{ textAlign: "center" }}>
        <a
          style={{ fontWeight: "300", fontSize: "12px" }}
          href={url}
          target="_blank"
        >
          {url}
        </a>
      </div>
    );
  };
  const renderActionButton = (data) => {
    const download = () => {
      let payload = [data.fileName]
      getInlineImageForCsvUpload(payload).then((res) => {
        if (res===undefined) return;
        if (res.data.success) {
          window.open(res.data.data[data.fileName], '_blank');
        }
      });
    };
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          shape="circle"
          type="dashed"
          icon={<DownloadOutlined />}
          onClick={() => download("hello")}
        />
      </div>
    );
  };
  const renderActionButtonLog = (data) => {
    const download = () => {
      let payload = [data.logFileName]
      getInlineImageForCsvUpload(payload).then((res) => {
        if (res===undefined) return;
        if (res.data.success) {
          window.open(res.data.data[data.logFileName], '_blank');
        }
      });
      // let payload = {
      //   name: `${data.soId}.log`,
      //   type: "log",
      //   crawling: true,
      // };
      // fetchAttachmentURL(payload).then((res) => {
      //   if (res.data.success) {
      //     const linkSource = `${res.data.data.src}`;
      //     const downloadLink = document.createElement("a");
      //     document.body.appendChild(downloadLink);
      //     downloadLink.href = linkSource;
      //     downloadLink.target = "_self";
      //     downloadLink.download = data.soId;
      //     downloadLink.click();
      //   }
      // });
    };
    return (
      <div style={{ textAlign: "center" }}>
        <Button
          shape="circle"
          type="dashed"
          icon={<DownloadOutlined />}
          onClick={() => download("hello")}
        />
      </div>
    );
  };
  const refreshData = () => {
    if(!isRefreshing){
      setRefreshing(true);
      fetchData();
    }
  };
  const fetchData = () => {
    settabSearch('')
    setLoading(true);
    getCsvUploadedList().then((res) => {
      if (res===undefined) return;
      setTableParams({
        pagination: {
          current: 1,
          pageSize: 10,
        },
      });
      setRowData(res.data.data);
      setOrigRowData(res.data.data);
      setLoading(false);
      setRefreshing(false);
    });
  };

  const columns = [
    {
      title: renderTitle("File Name", 'start'),
      dataIndex: "fileName",
      width: "20%",
      render: (_, row) => (
        <span style={{ wordBreak: 'break-word',overflowWrap: 'break-word', }}>{renderPara(row===undefined?"":row.fileName===undefined?"":row.fileName)}</span>
      ),
    },
    ,
    {
      title: renderTitle("Submitted By", 'start'),
      dataIndex: "submitter",
      width: "15%",
      render: (_, render) => (
        <>
          <span>{renderPara(render===undefined?"":render.submitter===undefined?"":render.submitter)}</span>
        </>
      ),
    },
    {
      title: renderTitle("Seeker", 'start'),
      dataIndex: "seeker",
      width: "15%",
      render: (_, row) => (
        <>
          <span>
            {renderPara(row===undefined?"":row.seeker===undefined?"":row.seeker)}
          </span>
        </>
      ),
    },
    {
      title: renderTitle("Expert", 'start'),
      dataIndex: "expert",
      width: "15%",
      render: (_, row) => (
        <>
          <span>
            {renderPara(row===undefined?"":row.expert===undefined?"":row.expert)}
          </span>
        </>
      ),
    },
    {
      title: renderTitle("XLS File"),
      dataIndex: "url",
      width: "10%",
      render: (_, row) => (
        <>
          <span style={{ wordBreak: 'break-word',overflowWrap: 'break-word', }}>{renderActionButton(row)}</span>
        </>
      ),
    },
    {
      title: renderTitle("Log File"),
      dataIndex: "frequency",
      width: "10%",
      render: (_, row) => (
        <div style={{ textAlign: "center" }}>
          <span>{renderActionButtonLog(row)}</span>
        </div>
      ),
    },
    {
      title: renderTitle("Uploaded Time", 'start'),
      dataIndex: 'uploadedTime',
      width: "15%",
      render: (_, render) => (
        <>
          <span>{renderPara(momentit(render===undefined?"":render.uploadedTime===undefined?"":render.uploadedTime))}</span>
        </>
      ),
    }
  ];
  const onChange = (pagination, filters, sorter, extra) => {
    setTableParams({ pagination: { pagination } });
  };
  useEffect(() => {
    fetchData();
  }, []);
  return (
    <div style={{width:'100%',margin:'auto'}}>
      <div
        className="mb-2 mt-2"
        style={{
          display: "flex",
          boxShadow: "7px 7px 20px lightgrey",
          backgroundColor: "#FAFAFA",
          justifyContent: "space-between",
          border: "1px solid #FAFAFA",
          alignItems: "center",
          borderRadius: "6px",
          padding: "8px",
        }}
      >
        <div style={{ display: "flex" }}>
          <span>
            <Input
            value={tabSearch}
              allowClear
              onChange={(val) => onChangeFilterStr(val.target.value)}
              placeholder="Search for file..."
              prefix={<SearchOutlined />}
            />
          </span>
        </div>
        <div>
          <span>
            <Tooltip title={tooltipTitle("Refresh List")} color="#fafafa">
            <SyncOutlined
              colSpan={3}
              span={2}
              onClick={() => refreshData()}
              spin={isRefreshing}
              style={{ fontSize: "16px" }}
            />
            </Tooltip>
          </span>
        </div>
      </div>
      <Spin spinning={isLoading}>
        <Table
          rowClassName={(record, index) => index % 2 === 0 ? 'table-row-light' :  'table-row-dark'}
          columns={columns}
          showSorterTooltip={false}
          dataSource={rows}
          rowKey={(record) => record}
          onChange={onChange}
          // pagination={false}
          className="mb-5"
          style={{ boxShadow: "7px 7px 20px lightgrey" }}
        />
      </Spin>
    </div>
  );
}
